import { network } from 'services/network';
import { useMutation } from 'react-query';

const setAssociateCardWithLogicChecker = (params) => {
    return network.post('api/bo/associateCardWithLogicChecker', params).then((response) => {
        return response.data;
    });
};
export const useMutationSetAssociateCardWithLogicChecker = () => {
    return useMutation<any, QueryError, ISetAssociateCardWithLogicCheckerPayload>('copyQualitySettings', (params) =>
        setAssociateCardWithLogicChecker(params),
    );
};

export interface ISetAssociateCardWithLogicCheckerPayload {
    metaDataId?: number;
    checkId?: number;
    cardId: number;
}
